import { lazy } from "react";

import { Box, Button, Heading, Stack, Text, Var } from "@seneca/senekit";

import { SUBSCRIPTION_TIERS } from "seneca-common/features/subscriptions/features/subscription-products/state/models/state/subscription-products/subscription-product/productDescription/ProductDescription";

import { getTierNameHeader } from "features/subscriptions/helpers";

const TransferSuccessAnimation = lazy(
  () =>
    import(
      /* webpackChunkName: "transfer-subscription-success-animation" */ "../animations/TransferSuccessAnimation"
    )
);

export default function TransferSuccessPage({
  displayName,
  tierName,
  onContinueClick
}: {
  displayName: string;
  tierName?: SUBSCRIPTION_TIERS;
  onContinueClick: () => void;
}) {
  const tier = getTierNameHeader(tierName);

  return (
    <Box
      display="flex"
      flexDirection="column"
      paddingX={["none", "large"]}
      paddingTop={["none", "xlarge"]}
      minHeight={["100%", "400px"]}
      justifyContent="space-between"
      alignItems="center"
    >
      <Stack align="center">
        <TransferSuccessAnimation />
        <Stack space="xlarge" align="center">
          <Heading align="center" level="4">
            Subscription successfully transferred{" "}
            {displayName ? (
              <>
                to <Var>{displayName}</Var>
              </>
            ) : (
              ""
            )}
          </Heading>
          <Text align="center">
            Next time {displayName ? <Var>{displayName}</Var> : "your child"}{" "}
            logs in, they'll get access to everything{" "}
            {tier ? tier : "your premium package"} has to offer
          </Text>
        </Stack>
      </Stack>
      <Box padding="xlarge" />
      <Button width={["100%", "auto"]} onClick={onContinueClick}>
        Got it
      </Button>
    </Box>
  );
}
